import { combineReducers } from "redux";
import { GET_DATA_DASHBOARD2_SUCCEEDED, GET_DATA_DASHBOARD3_SUCCEEDED, GET_DATA_DASHBOARD4_SUCCEEDED, GET_DATA_DASHBOARD5_SUCCEEDED, GET_DATA_DASHBOARD6_SUCCEEDED, GET_DATA_DASHBOARD_SUCCEEDED, GET_DATA_PLAN_DASHBOARD_SUCCEEDED, GET_DATA_PLAN_NEXTWEEK_DASHBOARD_SUCCEEDED, GET_DATA_PLAN_TIMEEXTENTION_DASHBOARD_SUCCEEDED, REQUERT_DATA_DASHBOARD_FAILED, REQUERT_DATA_PLAN_DASHBOARD_FAILED } from "../actions/actionTypes";

const dashboardReducer = (DataDashboard = [], actions) => {
    switch (actions.type) {
        case GET_DATA_DASHBOARD_SUCCEEDED:
            if (Object.keys(actions.DataDashboard).length > 0) {
                return { ...DataDashboard, DataDashboard: actions.DataDashboard };
            }
            else {
                return { ...DataDashboard, DataDashboard: [] };
            }
        case REQUERT_DATA_DASHBOARD_FAILED:
            return { ...DataDashboard, DataDashboard: [] }
        default:
            return DataDashboard;
    }
}
const dashboard2Reducer = (DataDashboard2 = [], actions) => {
    switch (actions.type) {
        case GET_DATA_DASHBOARD2_SUCCEEDED:
            if (Object.keys(actions.DataDashboard2).length > 0) {
                return { ...DataDashboard2, DataDashboard2: actions.DataDashboard2 };
            }
            else {
                return { ...DataDashboard2, DataDashboard2: [] };
            }
        case REQUERT_DATA_DASHBOARD_FAILED:
            return { ...DataDashboard2, DataDashboard2: [] }
        default:
            return DataDashboard2;
    }
}
const dashboard3Reducer = (DataDashboard3 = [], actions) => {
    switch (actions.type) {
        case GET_DATA_DASHBOARD3_SUCCEEDED:
            if (Object.keys(actions.DataDashboard3).length > 0) {
                //console.log('3',actions.DataDashboard3);
                return { ...DataDashboard3, DataDashboard3: actions.DataDashboard3 };
            }
            else {
                return { ...DataDashboard3, DataDashboard3: [] };
            }
        case REQUERT_DATA_DASHBOARD_FAILED:
            return { ...DataDashboard3, DataDashboard3: [] }
        default:
            return DataDashboard3;
    }
}
const dashboard4Reducer = (DataDashboard4 = [], actions) => {
    switch (actions.type) {
        case GET_DATA_DASHBOARD4_SUCCEEDED:
            if (Object.keys(actions.DataDashboard4).length > 0) {
                //console.log('4',actions.DataDashboard4);
                return { ...DataDashboard4, DataDashboard4: actions.DataDashboard4 };
            }
            else {
                return { ...DataDashboard4, DataDashboard4: [] };
            }
        case REQUERT_DATA_DASHBOARD_FAILED:
            return { ...DataDashboard4, DataDashboard4: [] }
        default:
            return DataDashboard4;
    }
}
const dashboard5Reducer = (DataDashboard5 = [], actions) => {
    switch (actions.type) {
        case GET_DATA_DASHBOARD5_SUCCEEDED:
            if (Object.keys(actions.DataDashboard5).length > 0) {
                return { ...DataDashboard5, DataDashboard5: actions.DataDashboard5 };
            }
            else {
                return { ...DataDashboard5, DataDashboard5: [] };
            }
        case REQUERT_DATA_DASHBOARD_FAILED:
            return { ...DataDashboard5, DataDashboard5: [] }
        default:
            return DataDashboard5;
    }
}
const dashboard6Reducer = (DataDashboard6 = [], actions) => {
    switch (actions.type) {
        case GET_DATA_DASHBOARD6_SUCCEEDED:
            if (Object.keys(actions.DataDashboard6).length > 0) {
                return { ...DataDashboard6, DataDashboard6: actions.DataDashboard6 };
            }
            else {
                return { ...DataDashboard6, DataDashboard6: [] };
            }
        case REQUERT_DATA_DASHBOARD_FAILED:
            return { ...DataDashboard6, DataDashboard6: [] }
        default:
            return DataDashboard6;
    }
}
const planDashboardReducer = (DataPlan = [], actions) =>{
    switch (actions.type) {
        case GET_DATA_PLAN_DASHBOARD_SUCCEEDED:
            if (Object.keys(actions.DataPlan).length > 0) {
                return { ...DataPlan, DataPlan: actions.DataPlan };
            }
            else {
                return { ...DataPlan, DataPlan: [] };
            }
        case REQUERT_DATA_PLAN_DASHBOARD_FAILED:
            return { ...DataPlan, DataPlan: [] }
        default:
            return DataPlan;
    }
}
const planDashboardNextWeekReducer = (DataNextWeek = [], actions) =>{
    switch (actions.type) {
        case GET_DATA_PLAN_NEXTWEEK_DASHBOARD_SUCCEEDED:
            if (Object.keys(actions.DataNextWeek).length > 0) {
                return { ...DataNextWeek, DataNextWeek: actions.DataNextWeek };
            }
            else {
                return { ...DataNextWeek, DataNextWeek: [] };
            }
        case REQUERT_DATA_PLAN_DASHBOARD_FAILED:
            return { ...DataNextWeek, DataNextWeek: [] }
        default:
            return DataNextWeek;
    }
}
const planDashboardTimeExtendtionReducer = (DataTimeExtend = [], actions) =>{
    switch (actions.type) {
        case GET_DATA_PLAN_TIMEEXTENTION_DASHBOARD_SUCCEEDED:
            if (Object.keys(actions.DataTimeExtend).length > 0) {
                return { ...DataTimeExtend, DataTimeExtend: actions.DataTimeExtend };
            }
            else {
                return { ...DataTimeExtend, DataTimeExtend: [] };
            }
        case REQUERT_DATA_PLAN_DASHBOARD_FAILED:
            return { ...DataTimeExtend, DataTimeExtend: [] }
        default:
            return DataTimeExtend;
    }
}
const mainALLReducer = combineReducers({
    dashboardReducer,dashboard2Reducer,dashboard3Reducer,dashboard4Reducer, dashboard5Reducer, dashboard6Reducer, planDashboardReducer, planDashboardNextWeekReducer, planDashboardTimeExtendtionReducer
})
export default mainALLReducer;